module.exports = __webpack_public_path__ + "img/rwanda@4x.0401dfd8.png";